import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import "core-js/features/array/at";
import "core-js/features/promise/all-settled";
import "core-js/features/promise/with-resolvers";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://d0a37f5ba7bdcbf8c7ccf7ca8e4251a5@o4505861761400832.ingest.us.sentry.io/4508936783003648",
  environment: import.meta.env.MODE,
  enabled: import.meta.env.MODE === "production",
});

const router = createBrowserRouter(
  createRoutesFromElements(<Route path="*" element={<App />} />),
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
